import { render, staticRenderFns } from "./QuizOptions.vue?vue&type=template&id=35d03a3c&scoped=true&"
import script from "./QuizOptions.vue?vue&type=script&lang=js&"
export * from "./QuizOptions.vue?vue&type=script&lang=js&"
import style0 from "./QuizOptions.vue?vue&type=style&index=0&id=35d03a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d03a3c",
  null
  
)

export default component.exports